import React from "react";
import { colors } from "src/styles";
import styled from "styled-components";
import { ClientsTableProps } from "../types";

export const FormTable = ({ isLoading, headers, data, onRowClick }: ClientsTableProps) => {
  if (isLoading) {
    return <EmptyRow>Loading...</EmptyRow>;
  }

  if (!data.length) {
    return <EmptyRow>No Form available</EmptyRow>;
  }

  return (
    <TableWrap>
      <TableHeader>
        {headers.map((header) => (
          <span key={header}>{header}</span>
        ))}
      </TableHeader>
      {data.map((item, index) => {
        return (
          <TableRow key={item.id} onClick={() => onRowClick(item.id)}>
            <IdPill>{index + 1}</IdPill>
            <NameCell>{item.name}</NameCell>
          </TableRow>
        );
      })}
    </TableWrap>
  );
};

const EmptyRow = styled.div`
  padding: 20px 16px;
  color: ${colors.grey.dark6};
  font-size: 13px;
`;

const TableWrap = styled.div`
  overflow-x: auto;
`;

const TableGridBase = styled.div`
  display: grid;
  grid-template-columns: 110px minmax(260px, 1fr);
  gap: 8px;
  align-items: center;
  min-width: 460px;
`;

const TableHeader = styled(TableGridBase)`
  padding: 12px 16px;
  color: ${colors.grey.dark6};
  border-bottom: 1px solid ${colors.grey.light3};
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 600;
`;

const TableRow = styled(TableGridBase)`
  padding: 14px 16px;
  border-top: 1px solid ${colors.grey.light3};
  cursor: pointer;

  &:hover {
    background: ${colors.grey.light6};
  }
`;

const IdPill = styled.span`
  border: 1px solid ${colors.grey.light4};
  background: ${colors.grey.light6};
  font-size: 11px;
  font-weight: 700;
  color: ${colors.black.light1};
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 4px 8px;
  width: fit-content;
`;

const NameCell = styled.span`
  font-size: 13px;
  color: ${colors.black.dark1};
`;
